import useSWR from 'swr';
import { useTranslation } from 'react-i18next';
import { fetchDedaloApi } from '@/api/dedaloApi';

export function useDedaloApi(options, schema) {
    const { i18n } = useTranslation();

    const key = ['dedaloApi', options, i18n.language];

    const fetcher = async () => {
        const response = await fetchDedaloApi(options, schema, i18n.language);
        const { result, total } = response;
        return options.count ? { result, total } : result;
    };

    const { data, error, isLoading } = useSWR(key, fetcher);

    return { data, error, isLoading };
}
